module.exports = __webpack_public_path__ + "img/img_side_star.329bdc9a.png";